<template>
  <div class="page" id="page-insurance-detail" style="font-family:NanumSquareOTF;">

    <div class="header">
    <div class="container">
      <div class="section-insure">
        <div class="banners">
          <div class="banner">비교견적</div>
          <div class="banner schema">정비·수리</div>
        </div>

        <template>
          <div v-if="stepStatus === stepsValue[0]" class="title" style="margin-top: 30px;">비교견적을<br>산출중입니다.</div>
          <div v-else-if="stepStatus === stepsValue[1]" class="title" style="margin-top: 30px;">최저견적을<br>찾았습니다.</div>
          <div v-else-if="stepStatus === stepsValue[2]" class="title" style="margin-top: 30px;">예약일정을<br>확인하고 있습니다.</div>
          <div v-else-if="stepStatus === stepsValue[3]" class="title" style="margin-top: 30px;">{{reservation_confirmed_date}}<br>방문예정입니다.</div>
          <div v-else-if="stepStatus === '예약취소'" class="title" style="margin-top: 30px;">예약취소 되었습니다.</div>
        </template>
        <!--
        <div class="subtitle">
          이태우님께서 2019년 04월 11일에 신청하신 자동차 보험의 현대해상 상세 견적서는 다음과 같습니다.
        </div>-->
      </div>

      <!-- <template v-if="insureType === 'estimate'">
        <ul class="buttons">
          <router-link tag="li" class="button schema" v-if="data" :to="{ name: 'EstimateConsultation', query: { ectype: data[0].value[0].value + '보험', admin: 35, customer: this.setEstimateCustomerId, adminj : data[4].value[0].adminid, source : '홈피마이보험'} }" >{{data[0].value[0].value}}보험 가입상담</router-link>
          <li class="button" @click="openKakao(data[4].value[0].kakaotalk)" >담당사원 카카오톡</li>
        </ul>
      </template> -->

      <div v-if="stepStatus === stepsValue[0]" class="repairdetail-sub-title">
        <p>고객님을 위한 최저견적을 찾는중입니다.</p>
        <p>견적이 완료되면 카카오톡으로 알려드립니다.</p>
      </div>

      <div class="repair-steps">
        <el-steps :active="stepsValue.findIndex((step) => step === stepStatus)">
          <el-step
            v-for="(item) in stepsValue" :key="item"
            :title="item" />
        </el-steps>
      </div>

      <template v-if="stepStatus !== stepsValue[0]">
        <div v-for="( item, i) in repairEstimateCardData" :key="i"
          class="repair-estimate-card">
          <div class="estimate-card-title">
            <div style="display:flex; flex-direction:row;">
              <div v-if="stepStatus === stepsValue[2] || stepStatus === stepsValue[3] || stepStatus === stepsValue[5] && i === 0" class="title-icon">
                <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.205 0.455054C11.4149 0.246962 11.6983 0.129848 11.9939 0.129033C12.2895 0.128217 12.5735 0.243765 12.7846 0.450696C12.9956 0.657627 13.1168 0.939314 13.1218 1.23486C13.1269 1.5304 13.0154 1.81605 12.8115 2.03005L6.82349 9.51506C6.72058 9.6259 6.59637 9.71486 6.45829 9.7766C6.32021 9.83835 6.1711 9.87162 6.01987 9.87442C5.86864 9.87722 5.7184 9.84949 5.57813 9.7929C5.43786 9.73631 5.31044 9.65202 5.20349 9.54505L1.23599 5.57605C1.12546 5.47306 1.03681 5.34886 0.975321 5.21086C0.913833 5.07286 0.88077 4.92389 0.878105 4.77284C0.87544 4.62178 0.903227 4.47174 0.959808 4.33166C1.01639 4.19158 1.10061 4.06433 1.20743 3.9575C1.31426 3.85067 1.44151 3.76645 1.5816 3.70987C1.72168 3.65329 1.87172 3.6255 2.02278 3.62817C2.17383 3.63083 2.3228 3.6639 2.4608 3.72538C2.5988 3.78687 2.723 3.87552 2.82599 3.98605L5.96699 7.12555L11.1765 0.488055C11.1858 0.476435 11.1958 0.465413 11.2065 0.455054H11.205Z" fill="#00CD34"/>
                </svg>
              </div>
              <div>
                <p class="title-price">{{ Number(item.price) | number }}원</p>
                <p>{{ item.storeName }}</p>
              </div>
            </div>
            <!-- <button class="title-btn">
              상세보기 & 예약
            </button> -->
            <router-link v-if="stepStatus === stepsValue[1]" tag="button" class="title-btn"
              :to="{ name: 'RepairDetail2', query: { repairCompareId: item._id, selected: true } }">
              상세보기 & 예약
            </router-link>
            <router-link v-else-if="stepStatus === stepsValue[2] && i == 0" tag="button" class="title-btn2"
              :to="{ name: 'RepairDetail2', query: { repairCompareId: item._id, selected: true } }">
              상세보기
            </router-link>
            <router-link v-else-if="stepStatus === stepsValue[3] && i == 0" tag="button" class="title-btn2"
              :to="{ name: 'RepairDetail2', query: { repairCompareId: item._id, selected: true, decision: true } }">
              상세보기
            </router-link>
            <router-link v-else-if="stepStatus === '예약취소' && i == 0" tag="button" class="title-btn3"
              :to="{ name: 'RepairDetail2', query: { repairCompareId: item._id, selected: true, decision: true, canceled: true } }">
              상세보기
            </router-link>
            <router-link v-else-if="stepStatus === stepsValue[2] || stepStatus === stepsValue[3] || stepStatus === stepsValue[5]" tag="button" class="title-btn3"
              :to="{ name: 'RepairDetail2', query: { repairCompareId: item._id, selected: false } }">
              상세보기
            </router-link>
          </div>
          <div>
            <p>{{item.detail}}</p>
          </div>
<!--          <div v-for="(content,c) in item.detail.slice(0, 5)" :key="c">-->
<!--            <p>{{ content }}</p>-->
<!--          </div>-->
        </div>
      </template>

    </div>
    </div>

    <div class="footer">
      <div class="container">
        <masonry :cols="{default: 2, 700: 1}" :gutter="30">

          <div class="section-information clear">
            <ul v-if="accidentDetail && accidentDetail.detail">
              <li >
                <p class="label">접수일시</p>
                <p class="value">{{ accidentDetail.detail.date }}</p>
              </li>
              <li >
                <p class="label">차량정보</p>
                <p class="value">{{ accidentDetail.detail.carInfo }}</p>
              </li>
              <li >
                <p class="label">희망지역</p>
                <p class="value">{{ accidentDetail.detail.address }}</p>
              </li>
              <li >
                <p class="label">서비스항목</p>
                <p class="value">{{ accidentDetail.detail.service }}</p>
              </li>
              <li >
                <p class="label">남긴말씀</p>
                <p class="value">{{ accidentDetail.detail.clientSpeak }}</p>
              </li>
              <li >
                <p class="label">연락처</p>
                <p class="value">{{ accidentDetail.detail.client_contact }}</p>
              </li>
              <!-- <li>
                <button @click="$refs.modalSendTextModal.show();">접수번호 문자 발송</button>
              </li> -->
            </ul>
          </div>

          <div class="section-information manager" v-if="accidentDetail.manager" style="margin-bottom: 20px;">
            <div class="title" v-if="accidentDetail.manager && accidentDetail.manager.title">
              {{ accidentDetail.manager.title }}
            </div>
            <div class="circle profile" v-if="accidentDetail.manager" :style="{'background-image': `url(${accidentDetail.manager.profileUrl})`}"
                style='background-repeat: no-repeat;background-position: center;background-size:cover;'>
            </div>
            <div class="item-frame">
              <div class="item">
                {{ accidentDetail.manager.name }}
              </div>

              <div class="item">
                {{ accidentDetail.manager.phone }}
              </div>

              <div class="item">
                {{ accidentDetail.manager.email }}
              </div>
            </div>

          </div>
        </masonry>

      </div>
    </div>
    <!-- 하단부 버튼 -->
    <div class="btn-double">
      <router-link tag="div" class="left"
        :to="{ name: 'EstimateConsultation', query: { ectype: '정비수리비교', admin: accidentDetail.manager.adminid, customer: $store.state.customer.profile._id } }" >
        비교견적 상담
      </router-link>
      <div class="right" @click="openKakao(accidentDetail.manager.kakaotalk)" >담당사원 카카오톡</div>
    </div>
  </div>
</template>

<script>
import ButtonBottom from '@/components/Elements/ButtonBottom'
import ButtonBottom2 from '@/components/Elements/ButtonBottom2'
import FloatingButton from '@/components/Elements/FloatingButton'
import Vue from 'vue'
import moment from 'moment'
import { Checkbox, Tooltip, Rate, Steps, Step } from 'element-ui'
import 'moment/locale/ko'

const PROGRESS = {
  '견적요청': '견적요청',
  '응답대기': '견적요청',
  '견적발송': '견적완료',
  '예약요청': '예약요청',
  '예약확정': '예약확정',
  '정비진행': '예약확정',
  '변경요청': '예약확정',
  '수리완료': '수리완료',
}

Vue.use(Checkbox)
Vue.use(Tooltip)
Vue.use(Rate)
Vue.use(Steps)
Vue.use(Step)

export default {
  components: {
    ButtonBottom, ButtonBottom2, FloatingButton
  },
  data() {
    return {
      // 견적표 가격 및 가게 상호 카드 데이터
      repairEstimateCardData: [],
      // 상태 바
      stepsValue: ['견적요청', '견적완료', '예약요청', '예약확정', '수리완료'],
      stepStatus: '견적요청',
      insureType: "",

      accidentDetail:
        {
          estimate_type: '',
          detail: {
          },
          manager: {
            title: "담당사원 정보",
            email: ""
          }
        },
    }
  },
  created(){
    this.stepStatus = this.stepsValue[0]
    this.$store.dispatch('repair/get', { repairId: this.$route.query.repairId })
    .then(({data: {data: item}}) => {
      this.stepStatus = PROGRESS[item.repair_estimate_status] || item.repair_estimate_status
      this.insureType = item.repair_estimate_type
      this.reservation_confirmed_date = moment(item.reservation_confirmed_date || item.desired_reservation_date).format('YYYY.MM.DD')
      this.accidentDetail = {
        detail: {
          client: item.customer_name,
          client_contact: item.customer_phone_number,
          address: item.desired_area,
          date: moment(item.repair_estimate_date).format('YYYY.MM.D a h:mm:ss'),
          carInfo: item.autocode_name,
          service: item.repair_items,
          clientSpeak: item.reservation_memo,
        },
        manager: {
          title: "담당사원 정보",
          name: item.admin_name,
          adminid: item.admin_id_report,
          email: item.admin_email,
          profileUrl: item.adminProfileUrl,
          phone: item.admin_contact_phone,
          kakaotalk: 'https://pf.kakao.com/_UhAjxl/chat',
        }
      }
    })
    this.get_repair_estimate_compares()
  },
  methods: {
    get_repair_estimate_compares() {
      return this.$store.dispatch('repair/getCompareItems', { repairId: this.$route.query.repairId })
                .then(({data}) => {
                  this.repairEstimateCardData = data.data.items.map(datum => ({
                    price: datum.amount,
                    storeName: datum.company_name,
                    detail: datum.memo,
                    address: datum.address,
                    phone: datum.tel_number,
                    _id: datum._id
                  }))
                  return data
                })
    },
    openKakao(link){
      window.open(link);
    },
    callPhone(link){
      window.open("tel:" + link);
    }
  }
}
</script>

<style lang="scss">
  .repair-estimate-card {
    margin-bottom: 30px;
    padding: 10px;
    border: 1.5px solid #D9D9D9;
    color: #656565;

    .estimate-card-title {
      border-bottom: 1px solid #D9D9D9;
      padding-bottom: 10px;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title-icon {
        margin-left: 10px;
        margin-right: 10px;
        display: flex;
        align-items: center;
      }
      .title-price {
        color:black;
        font-weight: bold;
        font-size: 16px;
      }
      .title-btn {
        width: 140px;
        height: 40px;
        color: white;
        font-weight: bold;
        background-color: #174BE6;
        border-radius: 8px;
      }
      .title-btn2 {
        width: 100px;
        height: 40px;
        color: white;
        font-weight: bold;
        background-color: #00CD34;
        border-radius: 8px;
      }
      .title-btn3 {
        width: 100px;
        height: 40px;
        color: white;
        font-weight: bold;
        background-color: #999999;
        border-radius: 8px;
      }
    }
  }

  .repair-steps {
    margin-left: 35px;
    margin-top: 30px;
    margin-bottom: 60px;
    width: 80%;
    .el-step__icon {
      background: #C4C4C4;
      border: 0px;
      width: 12px;
      height: 12px;
    }
    .is-process {
      color: #00CD34;
      font-weight: 700;
      .el-step__icon {
        background: #00CD34;
      }
    }
    .is-wait {
      color: #C4C4C4;
    }
    .is-finish {
      color: #C4C4C4;
      .el-step__line {
        border-color: #C4C4C4;
      }
    }
    .el-step__title {
      margin-left: -8px;
      margin-top: -6px;
      font-family: NanumSquareOTF;
      font-style: normal;
      font-size: 12px;
      line-height: 32px;
      letter-spacing: -0.56px;
    }
  }

  .repairdetail-sub-title {
    margin-top: -15px;
    font-family: NanumSquareOTF;
    letter-spacing: -0.3px;
    color: #666666;
  }
  .floatingBtn-towing {
    width: 270px;
    height: 32;
    position: fixed;
    left: calc(50% - 300px/2);
    top: calc(97% - 36px/2 - 81px);
    background-color: #E6FAEB;
    border-radius: 30px;
    padding: 5px 15px 5px 15px;
    font-weight: bold;
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: center;
  }

  #page-insurance-detail .card-frame{overflow: auto;display: block;}
  #page-insurance-detail .noitems {color: #787878;text-align: center;background-color: white;padding: 2rem;}
  #page-insurance-detail .noitems img {width: 3rem;height: 3rem;margin: 1rem auto;}
  #page-insurance-detail .noitems button{color: white;background-color: #174be6;border-radius: 4px;height: 50px;line-height: 50px;margin-top: 2rem;margin-bottom: 3rem;}



#tabs .container {
    max-width: 620px;
    min-width: 420px;
    margin: 40px auto;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.9em;
    color: #888;
}

#tabs .tabcontent {
    padding: 30px;
    border: 1px solid #ccc;
    border-radius: 10px;
  box-shadow: 3px 3px 6px #e1e1e1
}
.estimate-badge {
  position: absolute;
  width: 38px;
  height: 18px;
  left: 12.88px;
  top: 10.5px;
  z-index: 1;

  padding: 2px 8px;
  font-family: NanumSquareOTF;
  font-style: normal;
  font-weight: 50;
  font-size: 12px;
  line-height: 14px;

  display: flex;
  align-items: center;
  letter-spacing: -0.3px;

  color: #FFFFFF;

  background: #626262;
  border-radius: 10px;
}
.estimate-badge-done {
  position: absolute;
  width: 38px;
  height: 18px;
  left: 12.88px;
  top: 10.5px;
  z-index: 1;

  padding: 2px 8px;
  font-family: NanumSquareOTF;
  font-style: normal;
  font-weight: 50;
  font-size: 12px;
  line-height: 14px;

  display: flex;
  align-items: center;
  letter-spacing: -0.3px;

  color: #FFFFFF;

  background: #174BE6;
  border-radius: 10px;
}
</style>
